__turbopack_context__.v({
  "PianoDownloadTableModal__Description": "_95jgBq_PianoDownloadTableModal__Description",
  "PianoDownloadTableModal__Download": "_95jgBq_PianoDownloadTableModal__Download",
  "PianoDownloadTableModal__FileTitle": "_95jgBq_PianoDownloadTableModal__FileTitle",
  "PianoDownloadTableModal__Help": "_95jgBq_PianoDownloadTableModal__Help",
  "PianoDownloadTableModal__Icon": "_95jgBq_PianoDownloadTableModal__Icon",
  "PianoDownloadTableModal__List": "_95jgBq_PianoDownloadTableModal__List",
  "PianoDownloadTableModal__ListDownload": "_95jgBq_PianoDownloadTableModal__ListDownload",
  "PianoDownloadTableModal__ListDownloadWrapper": "_95jgBq_PianoDownloadTableModal__ListDownloadWrapper",
  "PianoDownloadTableModal__ListFileSize": "_95jgBq_PianoDownloadTableModal__ListFileSize",
  "PianoDownloadTableModal__ListItem": "_95jgBq_PianoDownloadTableModal__ListItem",
  "PianoDownloadTableModal__ListSize": "_95jgBq_PianoDownloadTableModal__ListSize",
  "PianoDownloadTableModal__ListSize--showDashes": "_95jgBq_PianoDownloadTableModal__ListSize--showDashes",
  "PianoDownloadTableModal__ListTitle": "_95jgBq_PianoDownloadTableModal__ListTitle",
  "PianoDownloadTableModal__ListVersion": "_95jgBq_PianoDownloadTableModal__ListVersion",
  "PianoDownloadTableModal__ProductChooser": "_95jgBq_PianoDownloadTableModal__ProductChooser",
  "PianoDownloadTableModal__Table": "_95jgBq_PianoDownloadTableModal__Table",
  "PianoDownloadTableModal__Title": "_95jgBq_PianoDownloadTableModal__Title",
});
